/* Install once in the Shopify theme as assets/ahara-referral.js, loaded from layout/theme.liquid <head>.
   Signed tokens are minted by /r/:code; the orders/paid webhook verifies them from note_attributes.
   With REFERRAL_STOREFRONT_HOP=true, /r/:code redirects here first; this script stores the 30-day
   cookie and forwards to the cart permalink so the buyer still lands at checkout.
   Cart attributes carry into normal checkout, cart-page accelerated checkout and selling-plan
   (subscription) checkout. Product-page Buy Now skips the cart, so it relies on the native code. */
(()=>{
  const key='ahara_ref', valid=/^[A-Za-z0-9_-]+\.[a-f0-9]{64}$/;
  const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  const nativeFetch=window.fetch.bind(window);
  const url=new URL(location.href);
  const incoming=url.searchParams.get(key);
  if(incoming && valid.test(incoming)) {
    // Last referral click wins for 30 days. Backend validates embedded expiry.
    document.cookie=`${key}=${encodeURIComponent(incoming)}; Max-Age=2592000; Path=/; Secure; SameSite=Lax`;
  }
  // /r/:code lands here with ahara_checkout (variant) and ahara_discount so the cookie above is stored
  // before the buyer goes straight to checkout; an abandoned checkout is still credited on a later visit.
  const variant=url.searchParams.get('ahara_checkout'), code=url.searchParams.get('ahara_discount');
  if(incoming!==null||variant!==null||code!==null){
    for(const name of [key,'ahara_checkout','ahara_discount']) url.searchParams.delete(name);
    history.replaceState(history.state,'',url);
  }
  if(incoming && valid.test(incoming) && variant!==null && /^[0-9]{1,20}$/.test(variant) && (code===null || /^[A-Za-z0-9-]{1,40}$/.test(code))) {
    // Same-origin cart permalink only: one bottle, the affiliate's code, and the signed attribute.
    const q=new URLSearchParams();
    if(code) q.set('discount',code);
    q.set(`attributes[${key}]`,incoming);
    location.replace(`${root}cart/${variant}:1?${q}`);
    return;
  }
  const stored=document.cookie.split('; ').find(x=>x.startsWith(key+'='));
  let token='';
  try{token=stored?decodeURIComponent(stored.slice(key.length+1)):'';}catch{}
  if(!valid.test(token)) return;
  let pending=null;
  const sync=()=>pending||(pending=(async()=>{
    try {
      const cart=await nativeFetch(root+'cart.js',{credentials:'same-origin'}).then(r=>r.json());
      if(cart && cart.attributes && cart.attributes[key]===token) return;
      await nativeFetch(root+'cart/update.js',{method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{[key]:token}})});
    }catch{/* Purchase proceeds without attribution if the cart API is unavailable. */}
    finally{pending=null;}
  })());
  // Themes and apps that add to cart through fetch may start a fresh cart; re-assert after each change.
  window.fetch=function(input,init){
    const result=nativeFetch(input,init);
    const target=String(input&&input.url||input);
    if(/\/cart\/(add|change|clear)(\.js)?(\?|$)/.test(target)) result.then(sync,()=>{});
    return result;
  };
  sync();
  window.addEventListener('pageshow',e=>{if(e.persisted) sync();});
  // Hold the cart checkout submit until the attribute write lands (at most 1.5s), then continue it.
  document.addEventListener('submit',e=>{
    const form=e.target, submitter=e.submitter;
    if(!pending || !submitter || submitter.name!=='checkout' || typeof form.requestSubmit!=='function' || form.dataset.aharaRef) return;
    e.preventDefault(); form.dataset.aharaRef='1';
    Promise.race([pending,new Promise(r=>setTimeout(r,1500))]).then(()=>form.requestSubmit(submitter));
  },true);
})();
